module.exports = __webpack_public_path__ + "media/images/affiliates/affiliates-form-sent-e8873159a90f3cc5b7c01c45c20f4750.svg";